import { LabelType } from '@app/store/shared/models';
import { LabelDimensionsDto } from './label-dimensions.dto';

/* Nominal size plus per-axis tolerance, since rolls are cut loose; a constant, with no edit endpoint. */
export class LabelDimensions {
    readonly labelType: LabelType;
    readonly dpi: number;
    readonly dpiTolerance: number;
    readonly widthDots: number;
    readonly widthDotsTolerance: number;
    readonly lengthDots: number;
    readonly lengthDotsTolerance: number;

    constructor(dto: LabelDimensionsDto) {
        this.labelType = dto.labelType;
        this.dpi = dto.dpi;
        this.dpiTolerance = dto.dpiTolerance;
        this.widthDots = dto.widthDots;
        this.widthDotsTolerance = dto.widthDotsTolerance;
        this.lengthDots = dto.lengthDots;
        this.lengthDotsTolerance = dto.lengthDotsTolerance;
    }
}
